import { classNames } from '@cotera/client/app/components/utils';
export const Overlay: React.FC<{
  z: string;
  onClick?: () => void;
  className?: string;
}> = ({ z, onClick, className }) => {
  return (
    <div
      onClick={onClick}
      className={classNames('fixed inset-0 bg-gray-900/50', z, className)}
    />
  );
};
